import React from 'react';
import { Box, Flex, Text, Icon, Badge } from '@chakra-ui/react';
import {
    Calendar, Send, CreditCard, PlaneLanding,
} from 'lucide-react';
import BoxDataTable from 'views/global/BoxDataTable';
import { notificationGroupLabels, notificationTypeLabel, labelFor } from 'lib/labels';

function ChannelBadge({ channel }) {
    const isOta = channel === 'ota';
    return (
        <Badge
            colorScheme={isOta ? 'purple' : 'blue'}
            variant="subtle"
            borderRadius="full"
            px="8px"
            textTransform="uppercase"
            fontSize="10px"
        >
            {isOta ? 'OTA' : 'WhatsApp'}
        </Badge>
    );
}

function StatusBadge({ item }) {
    if (item.completion_status === 'paid') {
        return <Badge colorScheme="green" borderRadius="full" px="8px">Pagata</Badge>;
    }
    if (item.completion_status === 'submitted') {
        return <Badge colorScheme="blue" borderRadius="full" px="8px">Inviata</Badge>;
    }
    return <Badge colorScheme="orange" borderRadius="full" px="8px">In attesa</Badge>;
}

function SendStatusBadge({ status }) {
    if (status === 'sent') {
        return <Badge colorScheme="green" variant="subtle" borderRadius="full" px="8px">Inviata</Badge>;
    }
    return <Badge colorScheme="red" variant="subtle" borderRadius="full" px="8px">Fallita</Badge>;
}

export default function NotificationsPage() {
    return (
        <Box>
            <BoxDataTable
                title="Notifiche"
                src="/user/notifications/list"
                search={false}
                checkbox={false}
                defaultPerPage={50}
                defaultFilters={{ period: '72' }}
                rowHeading={(item, index, prevItem) => {
                    if (!item.notification_group) return null;
                    if (item.notification_group === prevItem?.notification_group) return null;
                    const isCityTax = item.notification_group === 'City Tax';
                    return (
                        <Flex align="center" gap="10px" px="4px" pt={index > 0 ? '16px' : '4px'} pb="8px">
                            <Icon
                                as={isCityTax ? CreditCard : PlaneLanding}
                                color="brand.500"
                                boxSize="22px"
                            />
                            <Text fontWeight="700" fontSize="20px" color="gray.600">
                                {labelFor(notificationGroupLabels, item.notification_group)}
                            </Text>
                        </Flex>
                    );
                }}
                tableContent={(item) => (
                    <Box>
                        <Flex align="center" gap="8px" mb="6px" flexWrap="wrap">
                            <Text fontWeight="600" fontSize="15px" color="gray.800">
                                {item.reservation_name ?? `Prenotazione #${item.reservation_id}`}
                            </Text>
                            {item.property_identifier && (
                                <Text fontSize="13px" color="gray.500">· {item.property_identifier}</Text>
                            )}
                            <ChannelBadge channel={item.channel} />
                            <StatusBadge item={item} />
                            <SendStatusBadge status={item.status} />
                        </Flex>
                        <Flex gap="16px" flexWrap="wrap">
                            <Text className="muted-text d-flex d-icon-5">
                                <Send /> {notificationTypeLabel(item.type)}
                            </Text>
                            <Text className="muted-text d-flex d-icon-5">
                                <Calendar /> {item.sent_at}
                            </Text>
                            {item.recipient && (
                                <Text className="muted-text">{item.recipient}</Text>
                            )}
                            {item.failure_reason && (
                                <Text className="muted-text" color="red.400" noOfLines={1}>
                                    {item.failure_reason}
                                </Text>
                            )}
                        </Flex>
                    </Box>
                )}
            />
        </Box>
    );
}
